// extracted by mini-css-extract-plugin
module.exports = {"container":"PinLabel_container__2c-wV","icon":"PinLabel_icon__2oVjY","label":"PinLabel_label__2xrS3"};